import { createQueryKey } from '../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../query/types';

const participantKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['notifications', scopeId, 'participants'] as const,
    id: (participantId: QueryKeyParam) =>
      createQueryKey({
        all: ['notifications', scopeId, 'participants', participantId] as const,
        detail: ['notifications', scopeId, 'participants', participantId, 'detail'] as const,
      }),
  });

const teamKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['notifications', scopeId, 'teams'] as const,
    id: (teamId: QueryKeyParam) =>
      createQueryKey({
        all: ['notifications', scopeId, 'teams', teamId] as const,
        detail: ['notifications', scopeId, 'teams', teamId, 'detail'] as const,
      }),
  });

const scopedIdKeys = (scopeId: QueryKeyParam, inheritedKeys: QueryKey) =>
  createQueryKey({
    all: [...inheritedKeys, scopeId] as const,
    participants: participantKeys(scopeId),
    teams: teamKeys(scopeId),
  });

const notificationsKeys = createQueryKey({
  all: ['notifications'] as const,
  id: (id) => scopedIdKeys(id, ['notifications']),
});

export { notificationsKeys };
